import React, { useContext } from "react";
import { AppContext } from "../contexts/AppContext";
import axiosHttp from "../config/axios.interceptor";
import { useDispatch } from "react-redux";
import { AuthContext } from "../contexts/AuthContext";

const BlockUser = ({ data }) => {
  const appContext = useContext(AppContext);

  const blockUser = async () => {
    try {
      const block = await axiosHttp.post(`block/${data?.userId}`);
      if (block.status === 201 || block.status === 201) {
        appContext.updateNotificationState({
          show: true,
          type: "success",
          message: block?.data?.message,
        });
        appContext.updateModalState();
      }
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  return (
    <div className="card-body">
      <div className={`row `}>
        <div className="block-header">
          <h3 className="block-head">
            You're about to {data?.isBlockedUser ? "Unblock" : "Block"}{" "}
            <b>
              {data?.fName && data?.fName} {data?.lName && data?.lName}
              {!data?.fName && !data?.lName && data?.userName}
            </b>
          </h3>
        </div>
        {!data?.isBlockedUser && (
          <div className="block-header">
            <p>
              You'll no longer be connected and will lose any endorsements or
              recommendations from this person
            </p>
          </div>
        )}
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="d-flex mt-4">
            <button
              type="button"
              className="btn btn-primary modal-btn"
              //   disabled={reason === ""}
              onClick={blockUser}
            >
              {data?.isBlockedUser ? "Unblock" : "Block"}
            </button>
            <button
              type="button"
              className="btn btn-outline-primary prime-btn mx-3"
              //   disabled={reason === ""}
              onClick={() => appContext.updateModalState()}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockUser;
